var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PrivacyPolicyApp',{staticClass:"top-content-privacy-policy",attrs:{"version":_vm.version,"language":_vm.$i18n.locale},on:{"isLoading":function($event){return _vm.$emit('isLoading', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }